import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Dropzone from "react-dropzone";
import { Link } from "react-router-dom";
import { Input, Row, Col, Card, CardBody, Button } from "reactstrap";

import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const AddCommonForm2 = ({ labels, isAddOrEdit, selectedRow, setSelectedRow, onChangeHandler, handleImageUpload }) => {
    const { t, i18n } = useTranslation();
    const [focused, setFocused] = useState({});
    const [formData, setFormData] = useState(selectedRow);
    const today = new Date().toISOString().split("T")[0];

    const modules = {
		toolbar: [
			[{ 'font': [] }],
			[{ 'header': '1'}, { 'header': '2'}, { 'header': [3, 4, 5, 6, false] }], // All heading levels
			[{ 'size': ['small', false, 'large', 'huge'] }], // Font sizes
			['bold', 'italic', 'underline', 'strike'], // Basic formatting
			[{ 'color': [] }, { 'background': [] }], // Text color and background
			[{ 'script': 'sub'}, { 'script': 'super' }], // Subscript / superscript
			[{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'indent': '-1'}, { 'indent': '+1' }], // Lists and indents
			[{ 'align': [] }], // Text alignment
			['blockquote', 'code-block'], // Blockquote and code block
			['link', 'image', 'video'], // Links, images, and videos
			['clean'] // Remove formatting
		],
		clipboard: {
			matchVisual: false,
		}
	}
	
	const formats = [
		'font',
		'header',
		'size',
		'bold', 'italic', 'underline', 'strike',
		'color', 'background',
		'script',
		'list', 'bullet', 'indent',
		'align',
		'blockquote', 'code-block',
		'link', 'image', 'video'
	]

    const onhandleFocus = (e) => {
        const id = e.target.id;
        setFocused((prevFocused) => ({ ...prevFocused, [id]: true }));
    }

    const handleChange = (name, value) => {
		setSelectedRow((prev) => ({
			...prev,
			[name]: value
		}))
	}

    // useEffect(() => {
    //     setFormData(selectedRow);
    // }, [selectedRow])

    return (
        <Row>
            { labels?.map((items) => {
                switch (items?.fieldName || items?.labelName) {
                    case 'text-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="text"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultValue={formData[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        );

                    case 'textarea-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        rows="4"
                                        type="textarea"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultValue={formData[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        );

                    case 'number-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="number"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultValue={formData[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        )

                    case 'check-box':
                        return (
                            <Col key={items?.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items?.labelName} className="col-form-label">{t(items?.labelName)}{items.required && <small className="text-danger"> *</small>}</label>
                                    <Input
                                        type="checkbox"
                                        className="form-control"
                                        placeholder={t(items.placeholder)}
                                        defaultChecked={selectedRow[items?.value]}
                                        name={items?.name}
                                        onChange={(e) => onChangeHandler(e)}
                                        id={items?.labelName}
                                        onBlur={onhandleFocus}
                                        focused={focused[items.labelName] && focused[items.labelName].toString()}
                                        required={items.required} />
                                </div>
                            </Col>
                        );

                    case 'date':
                        return (
                            <Col key={items.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}</label>
                                    <Input 
                                    type="date" 
                                    className="form-control" 
                                    id={items.labelName} 
                                    name={items.name} 
                                    min={today}
                                    defaultValue={(formData[items.value] || '')?.split('T')[0]}
                                    onChange={(e) => onChangeHandler(e)} 
                                    onBlur={onhandleFocus}
                                    focused={focused[items.labelName] && focused[items.labelName].toString()}
                                    required={items.required} 
                                    />
                                </div>
                            </Col>
                        )

                    case 'time':
                        return (
                            <Col key={items.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}</label>
                                    <Input 
                                    type="time" 
                                    className="form-control" 
                                    id={items.labelName} 
                                    name={items.name} 
                                    min={(Module.StartDate || '')?.split('T')[0]}
                                    defaultValue={(formData[items.value] || '')?.split('T')[0]}
                                    onChange={(e) => onChangeHandler(e)} 
                                    onBlur={onhandleFocus}
                                    focused={focused[items.labelName] && focused[items.labelName].toString()}
                                    required={items.required} 
                                    />
                                </div>
                            </Col>
                        )

                    case 'editor':
                        return (
                            <Col key={items.id} sm={6}>
                                <div className="mb-3">
                                    <label htmlFor={items.labelName} className="col-form-label">{t(items.labelName)}</label>
                                    <ReactQuill 
                                        theme="snow" 
                                        value={selectedRow[items.name]} 
                                        onChange={(value) => handleChange(items.name, value)}
                                        modules={modules}
                                        formats={formats}
                                        placeholder={t(items.placeholder)}
                                    />
                                </div>
                            </Col>
                        )

                    case 'file':
                        return (
                            <Col key={items.id} sm={6}>
                                <label htmlFor="Icon" className="col-form-label">{t(items.labelName)} <small className="text-danger">*</small></label>
                                <CardBody>
                                    <div>
                                        <Dropzone
                                            onDrop={(acceptedFiles) => {
                                                handleImageUpload(acceptedFiles);
                                            }}
                                            // disabled={isDisabled}
                                        >
                                            {({ getRootProps, getInputProps }) => (
                                                <div className="dropzone dz-clickable" style={{minHeight: '60px'}}>
                                                    <div className="dz-message needsclick" {...getRootProps()}>
                                                        {/* <div className="mb-3">
                                                            <i className="display-4 text-muted ri-upload-cloud-2-fill" />
                                                        </div> */}
                                                        <h5>{t('DropFile')}</h5>
                                                    </div>
                                                </div>
                                            )}
                                        </Dropzone>

                                        { (selectedRow[items?.value] ||  selectedRow.preview) &&
                                            <Card className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete" id="dropzone-preview">
                                                <div className="p-2">
                                                    <Row className="align-items-center">
                                                        <Col className="col-auto">
                                                            {selectedRow[items?.value] ? (
                                                                <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    src={selectedRow[items?.value]}
                                                                    // alt={f.name}
                                                                />
                                                            ) : (
                                                                <img
                                                                    data-dz-thumbnail=""
                                                                    height="80"
                                                                    className="avatar-sm rounded bg-light"
                                                                    alt={selectedRow.name}
                                                                    src={selectedRow.preview}
                                                                />
                                                            )}
                                                        </Col>
                                                        <Col>
                                                            <Link to="#" className="text-muted font-weight-bold">
                                                                {selectedRow.path}
                                                            </Link>
                                                            <p className="mb-0">
                                                                <strong>{selectedRow.formattedSize}</strong>
                                                            </p>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </Card>
                                        }
                                    </div>
                                </CardBody>
                            </Col> )
                    

                    default:
                        return null
                }
            })}
        </Row>
    )
}

export default AddCommonForm2